import React, { useEffect, useState } from "react";
import { BsFillPersonFill } from "react-icons/bs";
import { FaToilet } from "react-icons/fa6";
import { IoWoman } from "react-icons/io5";
import { useNavigate, useParams } from "react-router-dom";
import bed from "../../../Assets/propertyPage/bed.svg";
import hostelBed from "../../../Assets/propertyPage/hostelBed.png";
import washroom from "../../../Assets/propertyPage/washroom.svg";
import pgman from "../../../Assets/propertyPage/pgman.svg";
import Aos from "aos";
import "aos/dist/aos.css";
import axios from "axios";
import CallbackModal from "../Modal/CallbackModal";
import ScheduleVisit from "../Modal/SchduleVisit";

function Hostel() {
  const [resources, setResources] = useState([]);
  const [callBack, setCallBack] = useState(false);
  const [visit, setVisit] = useState(false);

  const { location } = useParams();
  console.log("Location: ", location);
  const deslugify = (str) =>
    str.replace(/-/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());

  let actualLocation = null;
  if (location) {
    actualLocation = deslugify(location);
  }
  // const fetchAllResources = () => {
  //   let query = {};
  //   if (location) {
  //     query.location = location;
  //   }
  //   let config = {
  //     method: "get",
  //     url: `${process.env.REACT_APP_API_URL}/resources/get_all_building/`,
  //     maxBodyLenght: Infinity,
  //     headers: {},
  //   };

  //   axios
  //     .request(config)
  //     .then((response) => {
  //       console.log("Response of fetchAllResoures: ", response.data);
  //       setResources(response.data.data);
  //     })
  //     .catch((error) => {
  //       console.log("Error in fetchAllResources: ", error);
  //     });
  // };

  const fetchAllResources = () => {
    let url = `${process.env.REACT_APP_API_URL}/resources/get_all_building/`;

    // Append location as a query param if available
    if (actualLocation) {
      url += `?location=${encodeURIComponent(actualLocation)}`;
    }

    let config = {
      method: "get",
      url: url,
      maxBodyLength: Infinity, // typo fix: maxBodyLenght → maxBodyLength
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of fetchAllResources: ", response.data);
        setResources(response.data.data);
      })
      .catch((error) => {
        console.log("Error in fetchAllResources: ", error);
      });
  };

  console.log("resources: ", resources);
  useEffect(() => {
    fetchAllResources();
  }, [location]);
  const navigate = useNavigate();
  useEffect(() => {
    Aos.init({
      duration: 1000, // Animation duration
      easing: "ease-in-out", // Animation easing
      once: true, // Animation happens only once when scrolled into view
    });
  }, []);
  return (
    <div className="md:px-16 px-6">
      {callBack && <CallbackModal onClose={() => setCallBack(false)} />}
      {visit && <ScheduleVisit onClose={() => setVisit(false)} />}
      {resources?.map((hostel, index) => (
        <div
          key={index}
          data-aos={`${hostel.aos}`}
          className="flex lg:flex-row flex-col w-full mb-5 mt-5"
          onClick={() => {
            if (location) {
              navigate(
                `/${hostel.state}/${hostel.city}/${location}/${hostel.slug}`
              );
            } else {
              navigate(`/${hostel.state}/${hostel.city}/${hostel.slug}`);
            }
          }}
        >
          <img
            src={hostel?.images[0] || ""}
            alt="Hostel Room"
            className="lg:w-[40%] w-full rounded-lg object-cover"
          />

          <div className="flex w-full">
            <div className="flex flex-col py-7 lg:px-4 xl:px-10 w-full">
              <div className="flex justify-between items-center">
                <div className="tracking-wide">
                  <h2 className="text-xl font-semibold ">
                    {hostel.nameBuilding}
                  </h2>
                  <p className="text-gray-500 py-3 font-semibold">
                    {hostel.pgAddress}, {hostel.city}, {hostel.state}
                  </p>
                </div>
                {hostel.pgType === "Male" ? (
                  <button className="flex items-center gap-2 bg-gray-200 px-3 py-1.5 rounded-full text-gray-700 shadow-lg">
                    <img src={pgman} alt="pg man" />
                    <h1 className="tracking-wide">Men's PG</h1>
                  </button>
                ) : (
                  <button className="flex items-center gap-2 bg-gray-200 px-3 py-1.5 rounded-full text-gray-700 shadow-lg">
                    <IoWoman size={26} color="black" />
                    <h1 className="tracking-wide">Women's PG</h1>
                  </button>
                )}
              </div>

              <a
                href={hostel.mapLink}
                target="_blank"
                className="w-fit text-xs font-semibold text-[#235784] p-2 px-4 cursor-pointer rounded-full border border-[#235784] "
                onClick={(e) => e.stopPropagation()}
              >
                See Location on Map
              </a>

              <div className="flex gap-2 mt-2 text-[#929292] text-xs tracking-wide ">
                {["Single", "Double", "Triple"].map((type) => (
                  <span
                    key={type}
                    className="bg-[#EEEEEE] px-2 py-1 rounded-full flex items-center gap-2"
                  >
                    <img src={bed} alt="bed image" />
                    <h1>{type}</h1>
                  </span>
                ))}
              </div>

              <div className="lg:mt-16 mt-2 flex sm:flex-row flex-col sm:justify-between justify-start sm:items-center items-start">
                <div className="tracking-wide">
                  <p className="text-[#A8A8A8] mt-3">Starts From</p>
                  <p className="text-2xl font-bold">{`₹${hostel.startingPrice}/mo*`}</p>
                </div>
                <div className="tracking-wide">
                  <div className="flex gap-2 mt-4">
                    <button
                      className="border border-[#235784] px-4 py-3 rounded-md text-[#235784]"
                      onClick={(e) => {
                        e.stopPropagation();
                        setCallBack(true);
                      }}
                    >
                      Request a call back
                    </button>
                    <button
                      className="bg-[#235784] text-white px-4 py-3 rounded-md"
                      onClick={(e) => {
                        e.stopPropagation();
                        setVisit(true);
                      }}
                    >
                      Schedule a Visit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default Hostel;
